import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from 'rxjs/operators';
import { VinValidateRequest } from "src/app/models/vin-validate/vin-validate-request";
import { VinCategory } from "src/app/models/vin/vin-category";
import { VinSaveAndVector } from "src/app/models/vin/vin-save-and-vector";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class VinService {

  private apiUrl = environment.apiUrl;
  private vinValidationList: VinSaveAndVector[] = [];

  constructor(private httpClient: HttpClient) {
  }

  getChassiValidation(country: string, vin: string, lang: string): Observable<VinSaveAndVector> {

    const request = new VinValidateRequest();
    request.country = country;
    request.vin = vin;
    request.language = lang;

    return this.httpClient.post<VinSaveAndVector>(`${this.apiUrl}/api/v2/vins/validate`, request)
      .pipe(
        map((response: VinSaveAndVector) => {
          return response;
        })
      );
  }

  getByCountryAndYear(country: string, modelYear: number): Observable<VinCategory[]> {
    return this.httpClient.get<VinCategory[]>(`${this.apiUrl}/api/v1/vins/search/${country}/${modelYear}`)
      .pipe(
        map((response: VinCategory[]) => {
          return response;
        })
      );
  }

  setAllVinValidationList(vinValidations: VinSaveAndVector[]) {
    this.vinValidationList = vinValidations;
  }

  getAllVinValidationList(): VinSaveAndVector[] {
    return this.vinValidationList;
  }

  getAllVinValidationListClean() {
    this.vinValidationList = [];
  }

}
